import {CxEvent} from '@spartacus/core';

export class EddlAfterInitializationEvent extends CxEvent {
  static readonly type = 'EddlAfterInitializationEvent';
}
